const rTabs = str => str.trim().replace(/^ {4}/gm, "");

module.exports = {
   api:"https://api.sharifcamp.ir/api/",
   //api:"http://localhost:3001/api/",
   host:"http://sharifcamp.ir/",
   //host:"http://localhost:3000/",
   apikey:"73076aef-6f7d-4d83-80cb-978194e9ee02",
   languages:{
    45:{
       code: 45,
       title: "Assembly (NASM 2.14.02)",
       value: "asm6502",
       sample:rTabs(`
       section	.text
   global _start

_start:

   xor	eax, eax
   lea	edx, [rax+len]
   mov	al, 1
   mov	esi, msg
   mov	edi, eax
   syscall

   xor	edi, edi
   lea	eax, [rdi+60]
   syscall

section	.rodata

msg	db 'hello, world', 0xa
len	equ	$ - msg
        `)
     },
     46:{
       code: 46,
       title: "Bash (5.0.0)",
       value: "bash",
       sample:rTabs(`
       echo "hello, world"
        `)
     },
     47:{
       code: 47,
       title: "Basic (FBC 1.07.1)",
       value: "basic",
       sample:rTabs(`
       PRINT "hello, world"
        `)
     },
     75:{
       code: 75,
       title: "C (Clang 7.0.1)",
       value: "c",
       sample:rTabs(`
       #include <stdio.h>

int main(void) {
 int x;
 scanf("%d", &x);
  printf("%d", x);
   return 0;
}
        `)
     },
     76:{
       code: 76,
       title: "C++ (Clang 7.0.1)",
       value: "cpp",
       sample:rTabs(`
       #include <iostream>

int main() {
 int x;
 std::cin >> x;
   std::cout << x;
   return 0;
}
        `)
     },
     48:{
       code: 48,
       title: "C (GCC 7.4.0)",
       value: "c",
       sample:rTabs(`
       #include <stdio.h>

int main(void) {
   int x;
 scanf("%d", &x);
 printf("%d", x);
   return 0;
}
        `)
     },
     52:{
       code: 52,
       title: "C++ (GCC 7.4.0)",
       value: "cpp",
       sample:rTabs(`
       #include <iostream>

int main() {
   int x;
 std::cin >> x;
   std::cout << x;
   return 0;
}
        `)
     },
     49:{
       code: 49,
       title: "C (GCC 8.3.0)",
       value: "c",
       sample:rTabs(`
       #include <stdio.h>

int main(void) {
   int x;
 scanf("%d", &x);
 printf("%d", x);
   return 0;
}
        `)
     },
     53:{
       code: 53,
       title: "C++ (GCC 8.3.0)",
       value: "cpp",
       sample:rTabs(`
       #include <iostream>

int main() {
   int x;
 std::cin >> x;
   std::cout << x;
   return 0;
}
        `)
     },
     50:{
       code: 50,
       title: "C (GCC 9.2.0)",
       value: "c",
       sample:rTabs(`
       #include <stdio.h>

int main(void) {
   int x;
 scanf("%d", &x);
 printf("%d", x);
   return 0;
}
        `)
     },
     54:{
       code: 54,
       title: "C++ (GCC 9.2.0)",
       value: "cpp",
       sample:rTabs(`
       #include <iostream>

int main() {
   int x;
 std::cin >> x;
   std::cout << x;
   return 0;
}
        `)
     },
     86:{
       code: 86,
       title: "Clojure (1.10.1)",
       value: "clojure",
       sample:rTabs(`
       (println "hello, world")
        `)
     },
     51:{
       code: 51,
       title: "C# (Mono 6.6.0.161)",
       value: "csharp",
       sample:rTabs(`
   using System;
       public class Hello {
           public static void Main() {
             int a;
             a = Convert.ToInt32(Console.ReadLine());
             Console.WriteLine(a);
           }
       }
        `)
     },
     55:{
       code: 55,
       title: "Common Lisp (SBCL 2.0.0)",
       value: "lisp",
       sample:rTabs(`
       (write-line "hello, world")
        `)
     },
     56:{
       code: 56,
       title: "D (DMD 2.089.1)",
       value: "d",
       sample:rTabs(`
       import std.stdio;
void main()
{
   writeln("hello, world");
}
        `)
     },
     57:{
       code: 57,
       title: "Elixir (1.9.4)",
       value: "elixir",
       sample:rTabs(`
       IO.puts "hello, world"
        `)
     },
     58:{
       code: 58,
       title: "Erlang (OTP 22.2)",
       value: "erlang",
       sample:rTabs(`
       main(_) ->
   io:fwrite("hello, world\n").
        `)
     },
     87:{
       code: 87,
       title: "F# (.NET Core SDK 3.1.202)",
       value: "fsharp",
       sample:rTabs(`
       printfn "hello, world"
        `)
     },
     59:{
       code: 59,
       title: "Fortran (GFortran 9.2.0)",
       value: "fortran",
       sample:rTabs(`
       program main
   print *, "hello, world"
end
        `)
     },
     60:{
       code: 60,
       title: "Go (1.13.5)",
       value: "go",
       sample:rTabs(`
       package main

import "fmt"

func main() {
   fmt.Println("hello, world")
}

        `)
     },
     88:{
       code: 88,
       title: "Groovy (3.0.3)",
       value: "groovy",
       sample:rTabs(`
       println "hello, world"
        `)
     },
     61:{
       code: 61,
       title: "Haskell (GHC 8.8.1)",
       value: "haskell",
       sample:rTabs(`
       main = putStrLn "hello, world"
        `)
     },
     62:{
       code: 62,
       title: "Java (OpenJDK 13.0.1)",
       value: "java",
       sample:rTabs(`
       import java.io.*;
public class Main {
    public static void main(String[] args) {
        int firstNum, secondNum, result;
      BufferedReader br = new BufferedReader(new InputStreamReader(System.in));
      try {
         System.out.println("Enter a first number:");
         firstNum = Integer.parseInt(br.readLine());
         System.out.println("Enter a second number:");
         secondNum = Integer.parseInt(br.readLine());
         
         System.out.println("The Result is: " + firstNum);
          System.out.println("The Result is: " + secondNum);
      } catch (IOException ioe) {
         System.out.println(ioe);
      }
    }
}
        `)
     },
     63:{
       code: 63,
       title: "JavaScript (Node.js 12.14.0)",
       value: "javascript",
       sample:rTabs(`
       var readline = require('readline');
var rl = readline.createInterface({
  input: process.stdin,
  output: process.stdout,
  terminal: false
});

rl.on('line', function(line){
    console.log(line);
})
        `)
     },
     78:{
       code: 78,
       title: "Kotlin (1.3.70)",
       value: "kotlin",
       sample:rTabs(`
       fun main() {
           println("hello, world")
       }
        `)
     },
     64:{
       code: 64,
       title: "Lua (5.3.5)",
       value: "etlua",
       sample:rTabs(`
       print("hello, world")
        `)
     },
     79:{
       code: 79,
       title: "Objective-C (Clang 7.0.1)",
       value: "objectivec",
       sample:rTabs(`
       #import <Foundation/Foundation.h>

int main() {
   @autoreleasepool {
       char name[10];
       scanf("%s", name);
       NSString *message = [NSString stringWithFormat:@"hello, %s\n", name];
       printf("%s", message.UTF8String);
   }
   return 0;
}
        `)
     },
     65:{
       code: 65,
       title: "OCaml (4.09.0)",
       value: "ocaml",
       sample:rTabs(`
       print_endline "hello, world"
        `)
     },
     67:{
       code: 67,
       title: "Pascal (FPC 3.0.4)",
       value: "pascal",
       sample:rTabs(`
       program Hello;
begin
   writeln ('hello, world')
end.

        `)
     },
     85:{
       code: 85,
       title: "Perl (5.28.1)",
       value: "perl",
       sample:rTabs(`
       my $name = <STDIN>;
print "hello, $name";
        `)
     },
     68:{
       code: 68,
       title: "PHP (7.4.1)",
       value: "php",
       sample:rTabs(`
       <?php
       $f = fopen( 'php://stdin', 'r' );
       
       while( $line = fgets( $f ) ) {
         echo $line;
       }
       
       fclose( $f );
       ?>
        `)
     },
     69:{
       code: 69,
       title: "Prolog (GNU Prolog 1.4.5)",
       value: "prolog",
       sample:rTabs(`
       :- initialization(main).
main :- write('hello, world\n').
        `)
     },
     70:{
       code: 70,
       title: "Python (2.7.17)",
       value: "python",
       sample:rTabs(`
       a=int(input()); print(a,end='');
        `)
     },
     71:{
       code: 71,
       title: "Python (3.8.1)",
       value: "python",
       sample:rTabs(`
       a=int(input()); print(a,end='');
        `)
     },
     80:{
       code: 80,
       title: "R (4.0.0)",
       value: "r",
       sample:rTabs(`
       cat("hello, world\n")
        `)
     },
     72:{
       code: 72,
       title: "Ruby (2.7.0)",
       value: "ruby",
       sample:rTabs(`
       puts "hello, world"
        `)
     },
     73:{
       code: 73,
       title: "Rust (1.40.0)",
       value: "rust",
       sample:rTabs(`
       fn main() {
           println!("hello, world");
       }
        `)
     },
     81:{
       code: 81,
       title: "Scala (2.13.2)",
       value: "scala",
       sample:rTabs(`
       object Main {
           def main(args: Array[String]) = {
               val name = scala.io.StdIn.readLine()
               println("hello, "+ name)
           }
       }
        `)
     },
     82:{
       code: 82,
       title: "SQL (SQLite 3.27.2)",
       value: "sql",
       sample:rTabs(`
       SELECT
   Name, COUNT(*) AS num_albums
FROM artists JOIN albums
ON albums.ArtistID = artists.ArtistID
GROUP BY Name
ORDER BY num_albums DESC
LIMIT 4;
        `)
     },
     83:{
       code: 83,
       title: "Swift (5.2.3)",
       value: "swift",
       sample:rTabs(`
       import Foundation
let name = readLine()
print("hello, \(name!)")
        `)
     },
     74:{
       code: 74,
       title: "TypeScript (3.7.4)",
       value: "typescript",
       sample:rTabs(`
       console.log("hello, world");
        `)
     },
     84:{
       code: 84,
       title: "Visual Basic.Net (vbnc 0.0.0.5943)",
       value: "visual-basic",
       sample:rTabs(`
       Public Module Program
  Public Sub Main()
     Console.WriteLine("hello, world")
  End Sub
End Module
        `)
     }

  }
}